import React, { useMemo } from 'react';
import ReactDom from 'react-dom';
import { Link, useLocation } from 'react-router-dom';
import cx from 'classnames';
import { formattedPathKey } from 'helpers/formattedPathKey';

import { get, getConfigProp, SiteConfigManager } from '@atlas/core';
import {
  availableClientProfileRoutes,
  bonusesAvailableRoutes,
  CLIENT_PROFILE_COMPONENT_TYPES,
  clientProfileRoutes,
  COMPONENT_TYPES,
} from '@atlas/routing';
import { Icon, Label, ScrollableContainer } from '@atlas/ui';

import BonusesRouter from 'components/ClientProfile/Bonuses/BonusesRouter';
import ClientProfileTabNavigation from 'components/ClientProfile/ClientProfileTabNavigation';
import ShortFooter from 'components/Footer/ShortFooter';

const { CLIENT_PROFILE } = COMPONENT_TYPES;
const { BONUSES } = CLIENT_PROFILE_COMPONENT_TYPES;
const { bonuses } = clientProfileRoutes;

const Bonuses = () => {
  const { pathname } = useLocation();
  const isSportRadarProject = getConfigProp('isSportRadarProject');

  const clientProfilePath = SiteConfigManager.getComponentPath(CLIENT_PROFILE);

  const clientProfileTabs = get(SiteConfigManager.getComponentOptions(CLIENT_PROFILE), 'tabs');
  const bonusesOptions = clientProfileTabs.find(({ type }) => type === BONUSES);

  const { isExpandedOnMobile, tabs = [] } = bonusesOptions;

  const activeTabs = useMemo(
    () =>
      tabs.filter(
        tab =>
          tab.isActive &&
          (!isSportRadarProject || tab.type !== CLIENT_PROFILE_COMPONENT_TYPES.BONUSES_FREEBET),
      ),
    [isSportRadarProject, tabs],
  );

  const className = cx(
    'bonus-history-content-to-scroll',
    isExpandedOnMobile && 'disable-top-navigation',
  );

  const goBackMessage = isExpandedOnMobile
    ? formattedPathKey(pathname, clientProfilePath)
    : availableClientProfileRoutes[BONUSES].name;

  return ReactDom.createPortal(
    <div className="profile-wrapper-absolute">
      <Link className="back-to-container" to={clientProfilePath}>
        <Icon className="icon-back" name="back" />
        <Label className="title-text" message={goBackMessage} />
      </Link>
      <ClientProfileTabNavigation
        availableRoutes={bonusesAvailableRoutes}
        clientProfilePath={clientProfilePath}
        isExpandedOnMobile={isExpandedOnMobile}
        tabPath={bonuses}
        tabs={activeTabs}
      />
      <ScrollableContainer className={className} id="content">
        <BonusesRouter tabs={activeTabs} />
        <ShortFooter />
      </ScrollableContainer>
    </div>,
    document.body,
  );
};

export default Bonuses;
